import React from "react"
import { connect } from "react-redux"
import { mapDispatchProps, mapStateToProps } from "../../../../store/store"

import Button from "../../../../components/button"
import { useLanguage } from "@languages/index"

const CampaignCancelComplete = (props: any) => {
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.pages.campaigns }

  let containerStyle = ""
  if (props.preferences.isMobile) {
    containerStyle = "flex w-[100dvw] h-[100dvh] flex-col bg-white py-10 px-5 overflow-scroll"
  } else {
    containerStyle = "relative flex flex-col w-[480px] max-h-[80dvh] bg-white py-10 px-5 rounded-2xl overflow-scroll"
  }

  return (
    <div className={`${containerStyle}`}>
      <div className="flex flex-col justify-center my-auto">
        <div className="flex flex-row pb-2 mb-10 justify-center mx-auto">
          <div className="flex flex-col text-center items-center">
            <div className="mb-6">
              <img src="/assets/icons/ic-complete.svg" />
            </div>

            <span className="font-bold text-2xl tracking-tighter">
              {languageTexts._payments_cancel_complete_text_1()}
            </span>

            <span className="text-sm mt-[88px]">{languageTexts._payments_cancel_complete_text_2()}</span>
          </div>
        </div>
        <div className="absolute left-0 right-0 bottom-0 flex flex-col gap-4">
          <Button
            buttonColor="BLACK"
            borderColor={"BLACK"}
            textColor="WHITE"
            text={languageTexts.confirm}
            onClick={() => {
              props.closeOverlays()
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(CampaignCancelComplete)
